export class OldPasswordException extends Error {
  constructor(error) {
    super(error)
  }
}